import React from 'react';
import './ChangePasswordModal.css';
import { Container, Row, Col, Modal, ModalBody, ModalHeader, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import { CommonButton } from '../../CommonComponents';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';
import closeImg from '../../../images/modalclose.png';
import { useSelector } from 'react-redux';

const ChangePasswordModal = ({ isModalLoading, isOpen, toggle, data, handleChangePswd, handlePasswordSubmit }) => {
    let userGetInfo = useSelector(state => state.UserGetReducer.userInfoDetail);
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered backdrop="static" className="UploadModal" id="changePswdModal"
        //  scrollable={true}
        >
            {isModalLoading && <CustomSpinner />}
            <ModalHeader>
                <div className='modalHeading flex-wrap justify-content-between mb-0'>
                    <div className='title text-left'>Change Password</div>
                    {userGetInfo && userGetInfo.is_password_changed === true ?
                        <div className='closeButton'>
                            <img
                                src={closeImg}
                                alt='close'
                                onClick={toggle}
                            />
                        </div>
                        : ""}
                </div>
            </ModalHeader>
            <ModalBody className='pl-0 pr-0 pb-0'>
                <Container>
                    <div className='uploadDocWrapper'>
                        <Row>
                            <Col xs={12}>
                                <Form onSubmit={handlePasswordSubmit}>
                                    <FormGroup>
                                        <Label for='currentPswd'>
                                            Current Password <span className='required'>*</span>
                                        </Label>
                                        <Input
                                            type='password'
                                            name='currentPswd'
                                            value={data.currentPswd || ''}
                                            onChange={handleChangePswd}
                                            id='currentPswd'
                                            placeholder='Current Password'
                                            required
                                            className='position-relative'
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for='newPswd'>
                                            New Password <span className='required'>*</span>
                                        </Label>
                                        <Input
                                            type='password'
                                            name='newPswd'
                                            value={data.newPswd || ''}
                                            onChange={handleChangePswd}
                                            id='newPswd'
                                            placeholder='New Password'
                                            required
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for='confirmPswd'>
                                            Confirm Password <span className='required'>*</span>
                                        </Label>
                                        <Input
                                            type='password'
                                            name='confirmPswd'
                                            value={data.confirmPswd || ''}
                                            onChange={handleChangePswd}
                                            id='confirmPswd'
                                            placeholder='Confirm Password'
                                            required
                                        />
                                    </FormGroup>
                                    <FormGroup check className='text-right'>
                                        <Input
                                            type="checkbox"
                                            name='isDeviceLogout'
                                            value={data.isDeviceLogout || false}
                                            onChange={handleChangePswd}
                                            id='isDeviceLogout'
                                        />
                                        {' '}
                                        <Label check>
                                            Logout from other device
                                        </Label>
                                    </FormGroup>
                                    <div className='btnBlockWrap'>
                                        {userGetInfo && userGetInfo.is_password_changed === true ?
                                            <CommonButton name={'Close'} btnClass={'btnSecondary'} type="button" onClick={toggle} />
                                            : ""}
                                        <CommonButton name={'Save'} btnClass={'btnPrimary'} type="submit" />
                                    </div>
                                </Form>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </ModalBody>
            <ModalFooter className='pt-0 pb-0'>
            </ModalFooter>
        </Modal>
    )
}

export default ChangePasswordModal
